import React from "react";
import { motion } from "motion/react";
import { MapPin, UtensilsCrossed, Phone, Star, Sparkles } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { gastronomia, WHATSAPP_LINK } from "../data/mock";

const GastronomiaSection = () => {
  const getWhatsAppUrl = (gastroName) => {
    const message = `Olá! Tenho interesse no pacote ${gastroName}. Gostaria de reservar.`;
    return `${WHATSAPP_LINK}?text=${encodeURIComponent(message)}`;
  };

  return (
    <section id="gastronomia" className="py-20 lg:py-28 gradient-warm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block text-[hsl(var(--coral))] text-sm font-semibold uppercase tracking-wider mb-4">
            Sabores Cariocas
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Gastronomia & Experiências Culinárias
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Descubra os melhores sabores do Rio de Janeiro com roteiros gastronômicos
            e experiências inesquecíveis.
          </p>
        </motion.div>

        {/* Gastronomia Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {gastronomia.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="group h-full overflow-hidden border-0 shadow-lg hover:shadow-2xl transition-all duration-300 bg-white">
                <div className="relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-52 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  <div className="absolute top-4 left-4">
                    <span className="inline-flex items-center gap-1 bg-[hsl(var(--golden))] text-gray-900 text-xs font-semibold px-3 py-1 rounded-full">
                      <UtensilsCrossed className="w-3 h-3" />
                      Gastronômico
                    </span>
                  </div>
                  <div className="absolute bottom-4 left-4 flex items-center gap-2 text-white text-sm">
                    <MapPin className="w-4 h-4" />
                    <span>{item.location}</span>
                  </div>
                </div>
                <CardContent className="p-5">
                  <h3 className="font-display text-lg font-semibold text-gray-900 mb-2">
                    {item.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    {item.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-5">
                    {item.includes.map((inc, i) => (
                      <span
                        key={i}
                        className="inline-flex items-center gap-1 bg-[hsl(var(--sand))] text-gray-700 text-xs px-3 py-1.5 rounded-full"
                      >
                        <Star className="w-3 h-3 text-[hsl(var(--golden))]" />
                        {inc}
                      </span>
                    ))}
                  </div>
                  <motion.a
                    href={getWhatsAppUrl(item.name)}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Button className="w-full bg-[hsl(var(--whatsapp))] hover:bg-[hsl(142_69%_38%)] text-white rounded-full py-3 h-auto font-medium gap-2">
                      <Phone className="w-4 h-4" />
                      Quero esse pacote
                    </Button>
                  </motion.a>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GastronomiaSection;
